import http from '../../http-common'
import { stripInvalidId } from '@/services/utils'

class ContatoDataService {
  getAll(param: string): Promise<any> {
    const teste = param == undefined ? '' : param

    return http.get('/contato/' + teste)
  }

  get(slug: string): Promise<any> {
    return http.get('/contato/' + slug)
  }

  update(slug: any, data: any): Promise<any> {
    const payload = stripInvalidId(data)
    return http.patch('/contato/atualizar/' + slug + '/', payload)
  }

  create(data: any): Promise<any> {
    const payload = stripInvalidId(data)
    return http.post('/contato/criar/', payload)
  }

  delete(slug: string): Promise<any> {
    return http.delete('/contato/deletar/' + slug + '/')
  }

  importVCF(data: any): Promise<any> {
    return http.post('/contato/upload-vcf/', data)
  }

  // Mesclar contatos duplicados no contato primário (pk)
  merge(
    pk: string,
    data: { merge_ids: string[]; fill_missing_fields?: boolean; preserve_secondary_notes?: boolean },
  ): Promise<any> {
    return http.post(`/contato/${pk}/merge/`, data)
  }

  // Transformação para Cliente - prévia do mapeamento
  transformPreview(pk: string): Promise<any> {
    return http.get(`/contato/${pk}/transform-preview/`)
  }

  // Transformação para Cliente - executar
  transformToCliente(
    pk: string,
    data: { cpf?: string; cnpj?: string; dados_complementares?: Record<string, any> } = {},
  ): Promise<any> {
    return http.post(`/contato/${pk}/transform-to-cliente/`, data)
  }

  // Métodos específicos para agenda/tarefas

  /**
   * Buscar contatos para seleção em tarefas
   * @param params Query parameters de filtro
   */
  searchContatosForTask(params: { search?: string; page?: number; page_size?: number }): Promise<any> {
    const queryParams = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value.toString())
      }
    })

    return http.get(`/contato/?${queryParams.toString()}`)
  }

  /**
   * Obter contato específico por UUID
   * @param uuid UUID do contato
   */
  getContatoByUuid(uuid: string): Promise<any> {
    return http.get(`/contato/${uuid}/`)
  }

  /**
   * Buscar leads vinculados a um contato específico
   * @param uuid UUID do contato
   * @param params Parâmetros de busca/paginação
   */
  getLeadsByContato(
    uuid: string,
    params: { search?: string; page?: number; page_size?: number; include_veiculos_proposta?: boolean } = {},
  ): Promise<any> {
    const queryParams = new URLSearchParams()

    // Usa /lead/?contact=<uuid> para aproveitar paginação e filtros ricos do LeadViewSet.
    // O endpoint alternativo /contato/<uuid>/leads/ existe no backend (não é legacy) e retorna
    // lista simples sem paginação — pode ser usado quando o payload completo for dispensável.
    queryParams.append('contact', uuid)

    // Incluir parâmetro para otimizar quando a UI consome veículos de proposta
    if (params.include_veiculos_proposta) {
      queryParams.append('include_veiculos_proposta', '1')
    }

    // Add other parameters (destructure to exclude include_veiculos_proposta which is already handled)
    const { include_veiculos_proposta, ...otherParams } = params
    Object.entries(otherParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value.toString())
      }
    })

    void include_veiculos_proposta

    return http.get(`/lead/?${queryParams.toString()}`)
  }

  getTimeline(uuid: string): Promise<any> {
    return http.get(`/contato/${uuid}/timeline/?include=direction,datetime,sender`)
  }

  /**
   * Inbox por contato (conversa contínua agregada)
   * GET /contato/<uuid>/inbox/
   */
  getInbox(
    uuid: string,
    params: {
      order?: 'asc' | 'desc'
      channel?: string
      direction?: 'incoming' | 'outgoing'
      lead_id?: number | string
      has_lead?: boolean | string | number
      limit?: number
    } = {},
  ): Promise<any> {
    const queryParams = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return
      if (key === 'has_lead' && typeof value === 'boolean') {
        queryParams.append(key, value ? 'true' : 'false')
      } else {
        queryParams.append(key, value.toString())
      }
    })

    const qs = queryParams.toString()
    const suffix = qs ? `?${qs}` : ''
    return http.get(`/contato/${uuid}/inbox/${suffix}`)
  }
}

export default new ContatoDataService()
